const CART_RETURN_PATH_KEY = "cartReturnFrom";

export const captureCartReturnPath = (): string => {
  const from = window.location.pathname + window.location.search;
  sessionStorage.setItem(CART_RETURN_PATH_KEY, from);
  return from;
};

export const getCartReturnPath = (): string | null => {
  return sessionStorage.getItem(CART_RETURN_PATH_KEY);
};
